import { render } from "./InquiryView.vue?vue&type=template&id=1141cd2c&scoped=true"
import script from "./InquiryView.vue?vue&type=script&lang=js"
export * from "./InquiryView.vue?vue&type=script&lang=js"

import "./InquiryView.vue?vue&type=style&index=0&id=1141cd2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1141cd2c"]])

export default __exports__